<template>
  <div class="share-coupon-manage-page">
    <div class="wScreenArea">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="wScreenCardHeader">
          <span>筛选查询</span>
        </div>
        <el-form
          :model="queryForm"
          label-position="left"
          label-width="90px"
          @submit.native.prevent
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="门店">
                <el-select
                  v-model="queryForm.storeId"
                  clearable
                  filterable
                  placeholder="请选择门店"
                  @change="handleStoreChange"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in storeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="券类型">
                <el-select
                  v-model="queryForm.couponType"
                  clearable
                  filterable
                  placeholder="请选择券类型"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in couponTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="使用时间">
                <el-date-picker
                  v-model="queryForm.dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="4"
              style="display: flex; align-items: center; gap: 8px"
            >
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>

    <div class="wTableArea">
      <el-card shadow="never">
        <el-table border :data="tableData" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" width="100" />
          <el-table-column label="券名称" align="center" min-width="320">
            <template slot-scope="scope">
              {{
                scope.row.name ||
                scope.row.couponName ||
                getCouponTypeText(scope.row) ||
                "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.updateTime || "-" }}
            </template>
          </el-table-column>
        </el-table>

        <div class="wPagination">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, sizes, prev, pager, next, jumper"
          />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getStaticCouponsApi,
  getStoreManagerListApi,
  store_storeInfoById,
} from "@/network/wApi.js";

const defaultQueryForm = () => ({
  storeId: "",
  couponType: "",
  dateRange: [],
});

const commonCouponTypeValues = ["M", "G"];

const allCouponTypeOptions = [
  { label: "满减免单福利券", value: "M" },
  { label: "口粮:平台补贴优惠券", value: "G" },
  { label: "非遗酸汤火锅:牛肉福利券", value: "FYST" },
  { label: "香辣牛骨锅:香辣牛骨福利券", value: "XLNG" },
  { label: "全牛小面:牛骨汤面福利券", value: "QNXM" },
  { label: "韩式烤肉:牛肉福利券", value: "HSKR" },
  { label: "牧歌烧烤:牛肉串福利券", value: "MGSK" },
  { label: "广式烤鸭(饭):烤鸭福利券", value: "GSKY" },
  { label: "美式炸鸡:炸鸡福利券", value: "MSZJ" },
  { label: "牧歌牛包子:牛肉包子福利券", value: "MGBZ" },
  { label: "铜锅涮肉:羔羊福利券", value: "TGSR" },
  { label: "辣辣卤鸭货:卤鸭货福利券", value: "LLYH" },
  { label: "重庆毛肚火锅:毛肚福利券", value: "CQHG" },
  { label: "社区卤菜厨房:卤菜福利券", value: "SQCF" },
];

export default {
  name: "ShareCouponManage",
  data() {
    return {
      loading: false,
      queryForm: defaultQueryForm(),
      storeOptions: [],
      selectedStoreTypes: [],
      allCouponTypeOptions,
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      couponTypeOptions: allCouponTypeOptions,
    };
  },
  mounted() {
    this.getStoreList();
    this.fetchTableData();
  },
  methods: {
    getStoreList() {
      this.loading = true;
      let userInfo = localStorage.getItem("USER_INFO");
      let userId = "";

      if (userInfo) {
        try {
          userInfo = JSON.parse(userInfo);
          userId = userInfo.id || "";
        } catch (error) {
          userId = "";
        }
      }

      getStoreManagerListApi({ userId })
        .then((res) => {
          if (Array.isArray(res)) {
            this.storeOptions = res.map((item) => ({
              id: item.id,
              name: item.storeName,
            }));
            this.updateCouponTypeOptions();
            return;
          }

          if (res && Array.isArray(res.records)) {
            this.storeOptions = res.records.map((item) => ({
              id: item.id,
              name: item.storeName,
            }));
            this.updateCouponTypeOptions();
            return;
          }

          this.storeOptions = [];
          this.updateCouponTypeOptions();
        })
        .catch(() => {
          this.storeOptions = [];
          this.updateCouponTypeOptions();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    normalizeStoreTypes(type) {
      if (Array.isArray(type)) {
        return type.filter(Boolean);
      }

      if (typeof type === "string") {
        return type
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
      }

      return [];
    },
    updateCouponTypeOptions() {
      if (!this.queryForm.storeId) {
        this.selectedStoreTypes = [];
        this.couponTypeOptions = this.allCouponTypeOptions;
        return;
      }

      const allowedValues = new Set([
        ...commonCouponTypeValues,
        ...this.selectedStoreTypes,
      ]);

      this.couponTypeOptions = this.allCouponTypeOptions.filter((item) =>
        allowedValues.has(item.value)
      );

      if (
        this.queryForm.couponType &&
        !allowedValues.has(this.queryForm.couponType)
      ) {
        this.queryForm.couponType = "";
      }
    },
    handleStoreChange(storeId) {
      if (!storeId) {
        this.selectedStoreTypes = [];
        this.updateCouponTypeOptions();
        return;
      }

      store_storeInfoById({ id: storeId })
        .then((res) => {
          this.selectedStoreTypes = this.normalizeStoreTypes(res && res.type);
          this.updateCouponTypeOptions();
        })
        .catch(() => {
          this.selectedStoreTypes = [];
          this.updateCouponTypeOptions();
        });
    },
    handleSearch() {
      this.pagination.current = 1;
      this.fetchTableData();
    },
    handleReset() {
      this.queryForm = defaultQueryForm();
      this.selectedStoreTypes = [];
      this.updateCouponTypeOptions();
      this.pagination.current = 1;
      this.fetchTableData();
    },
    fetchTableData() {
      const hasDateRange =
        this.queryForm.dateRange && this.queryForm.dateRange.length === 2;

      this.loading = true;
      getStaticCouponsApi({
        pageNum: this.pagination.current,
        pageSize: this.pagination.size,
        storeId: this.queryForm.storeId,
        type: this.queryForm.couponType,
        startTime: hasDateRange
          ? `${this.queryForm.dateRange[0]} 00:00:00`
          : "",
        endTime: hasDateRange
          ? `${this.queryForm.dateRange[1]} 23:59:59`
          : "",
      })
        .then((res) => {
          this.tableData = res.records || [];
          this.pagination.total = res.total || 0;
          this.pagination.current = res.current || this.pagination.current;
          this.pagination.size = res.size || this.pagination.size;
        })
        .catch(() => {
          this.tableData = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(page) {
      this.pagination.current = page;
      this.fetchTableData();
    },
    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.current = 1;
      this.fetchTableData();
    },
    getCouponTypeText(row) {
      const typeValue = row.type || row.couponType;
      const matched = this.couponTypeOptions.find(
        (item) => item.value === typeValue
      );

      if (matched) {
        return matched.label;
      }

      if (row.verificationConfigId) {
        return `配置ID：${row.verificationConfigId}`;
      }

      return typeValue || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.share-coupon-manage-page {
}
</style>
